import React from "react";
import styles from "./styles.module.scss";

const LoanAllocations = () => {
    return <div className={styles.table}></div>;
};
export default LoanAllocations;
